require("./bootstrap");
require("./jquery/gaEvent");
require("./jquery/checkout");
require("./jquery/payment");

const algoliasearch = require("algoliasearch");

const client = algoliasearch(
    $("#algolia_client").val(),
    $("#algolia_search_key").val()
);
let index = client.initIndex("hyalite_products");

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
        }
    });

    var slideWrapper = $(".main-slider"),
        iframes = slideWrapper.find(".embed-player"),
        lazyImages = slideWrapper.find(".slide-image"),
        lazyCounter = 0;

    // POST commands to YouTube or Vimeo API
    function postMessageToPlayer(player, command) {
        if (player == null || command == null) return;
        player.contentWindow.postMessage(JSON.stringify(command), "*");
    }

    // When the slide is changing
    function playPauseVideo(slick, control) {
        var currentSlide, slideType, startTime, player, video;

        currentSlide = slick.find(".slick-current");
        slideType = currentSlide.attr("class").split(" ")[1];
        player = currentSlide.find("iframe").get(0);
        startTime = currentSlide.data("video-start");

        if (slideType === "vimeo") {
            switch (control) {
                case "play":
                    if (
                        startTime != null &&
                        startTime > 0 &&
                        !currentSlide.hasClass("started")
                    ) {
                        currentSlide.addClass("started");
                        postMessageToPlayer(player, {
                            method: "setCurrentTime",
                            value: startTime
                        });
                    }
                    postMessageToPlayer(player, {
                        method: "play",
                        value: 1
                    });
                    break;
                case "pause":
                    postMessageToPlayer(player, {
                        method: "pause",
                        value: 1
                    });
                    break;
            }
        } else if (slideType === "youtube") {
            switch (control) {
                case "play":
                    postMessageToPlayer(player, {
                        event: "command",
                        func: "mute"
                    });
                    postMessageToPlayer(player, {
                        event: "command",
                        func: "playVideo"
                    });
                    break;
                case "pause":
                    postMessageToPlayer(player, {
                        event: "command",
                        func: "pauseVideo"
                    });
                    break;
            }
        } else if (slideType === "video") {
            video = currentSlide.children("video").get(0);
            if (video != null) {
                if (control === "play") {
                    video.play();
                } else {
                    video.pause();
                }
            }
        }
    }

    // Resize player
    function resizePlayer(iframes, ratio) {
        if (!iframes[0]) return;
        var win = $(".main-slider"),
            width = win.width(),
            playerWidth,
            height = win.height(),
            playerHeight,
            ratio = ratio || 16 / 9;

        iframes.each(function() {
            var current = $(this);
            if (width / ratio < height) {
                playerWidth = Math.ceil(height * ratio);
                current
                    .width(playerWidth)
                    .height(height)
                    .css({
                        left: (width - playerWidth) / 2,
                        top: 0
                    });
            } else {
                playerHeight = Math.ceil(width / ratio);
                current
                    .width(width)
                    .height(playerHeight)
                    .css({
                        left: 0,
                        top: (height - playerHeight) / 2
                    });
            }
        });
    }

    // DOM Ready
    $(function() {
        // Initialize
        slideWrapper.on("init", function(slick) {
            slick = $(slick.currentTarget);
            setTimeout(function() {
                playPauseVideo(slick, "play");
            }, 1000);
            resizePlayer(iframes, 16 / 9);
        });
        slideWrapper.on("beforeChange", function(event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, "pause");
        });
        slideWrapper.on("afterChange", function(event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, "play");
        });
        slideWrapper.on("lazyLoaded", function(
            event,
            slick,
            image,
            imageSource
        ) {
            lazyCounter++;
            if (lazyCounter === lazyImages.length) {
                lazyImages.addClass("show");
                // slideWrapper.slick("slickPlay");
            }
        });

        //start the slider
        slideWrapper.slick({
            // fade:true,
            autoplaySpeed: 4000,
            lazyLoad: "progressive",
            speed: 1000,
            arrows: false,
            dots: true,
            cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)"
        });
    });

    // Resize event
    $(window).on("resize.slickVideoPlayer", function() {
        resizePlayer(iframes, 16 / 9);
    });

    // Positive message timeout
    setTimeout(function() {
        $(".message.positive").animate(
            {
                height: "toggle",
                opacity: "toggle"
            },
            500
        );
    }, 5000);

    // Accordion
    if ($(".toggle .toggle-title").hasClass("active")) {
        $(".toggle .toggle-title.active")
            .closest(".toggle")
            .find(".toggle-inner")
            .show();
    }
    $(".toggle .toggle-title").click(function() {
        if ($(this).hasClass("active")) {
            $(this)
                .removeClass("active")
                .closest(".toggle")
                .find(".toggle-inner")
                .slideUp(200);
        } else {
            $(this)
                .addClass("active")
                .closest(".toggle")
                .find(".toggle-inner")
                .slideDown(200);
        }
    });

    // Default Slick Slider
    $(".main-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        fade: true,
        cssEase: "ease",
        autoplay: true,
        autoplaySpeed: 4000
    });

    $(".product__slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        cssEase: "ease",
        autoplay: false
    });

    $(".review-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        adaptiveHeight: false,
        cssEase: "ease",
        autoplay: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    dots: false
                }
            }
        ]
    });

    $(".prodlist-slider").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        cssEase: "linear",
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    $(".tilegroup__slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 200,
        autoplaySpeed: 3500,
        arrows: false,
        dots: true,
        fade: false,
        cssEase: "ease",
        autoplay: true
    });

    $(".product__slidernav").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: ".product__slider",
        focusOnSelect: true,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    // Convert .svg image to SVG format (add class="svg")
    $("img.svg").each(function() {
        var $img = $(this);
        var imgID = $img.attr("id");
        var imgClass = $img.attr("class");
        var imgURL = $img.attr("src");

        $.get(
            imgURL,
            function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find("svg");

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== "undefined") {
                    $svg = $svg.attr("id", imgID);
                }

                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== "undefined") {
                    $svg = $svg.attr("class", imgClass + " replaced-svg");
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr("xmlns:a");

                // Replace image with new SVG
                $img.replaceWith($svg);
            },
            "xml"
        );
    });

    $(".add-item").on("click", function(e) {
        e.preventDefault();
        let quantity = $("#product-quantity").val();
        let product_id = $(this).data("product-id");

        $.post("/add_item", {
            product: product_id,
            quantity: quantity !== undefined ? quantity : 1
        })
            .then(resp => {
                //console.log(resp);
                if (resp.success == false) return false;

                $(".cart_count").html(resp.cart_count);
                $(this).html("Added to Cart!");
                setTimeout(function() {
                    $(".add-item").html("Add to Cart");
                }, 1000);

                return new Promise((resolve, reject) => {
                    resolve({ success: true });
                });
            })
            .then(resp => {
                $.get("/products/" + product_id + "/details").then(resp => {
                    if (resp.success !== true) return true;
                    dataLayer.push({
                        event: "add_to_cart",
                        currency: resp.currency,
                        value: resp.price,
                        items: [
                            {
                                item_id: resp.sku,
                                item_name: resp.name,
                                currency: resp.currency,
                                index: 0,
                                item_brand: resp.brand,
                                item_category: resp.category,
                                item_list_id: "search_results",
                                item_list_name: "Search Results",
                                price: resp.price,
                                quantity: 1
                            }
                        ]
                    });
                });
            });
    });

    // Add to Cart QTY

    $(".product__qtyminus").on("click", function() {
        var input = $(this)
            .parent()
            .find("input");
        var count = parseInt(input.val()) - 1;
        count = count < 1 ? 1 : count;
        input.val(count);
        return false;
    });
    $(".product__qtyplus").on("click", function() {
        var input = $(this)
            .parent()
            .find("input");
        input.val(parseInt(input.val()) + 1);
        return false;
    });

    $("#add-item-product-modal").on("click", function(e) {
        e.preventDefault();

        let quantity = $("#product-quantity-modal").val();
        let product_id = $(this).data("product-id");

        $.post("/add_item", {
            product: product_id,
            quantity: quantity !== undefined ? quantity : 1
        })
            .then(resp => {
                //console.log(resp);
                if (resp.success == false) return false;

                $(".cart_count").html(resp.cart_count);
                $(this).html("Added to Cart!");
                setTimeout(function() {
                    $("#add-item-product-modal").html("Add to Cart");
                    setTimeout(function() {
                        $(".product__qtynumber").val(1);
                    }, 1500);
                }, 1000);

                return new Promise((resolve, reject) => {
                    resolve({ success: true });
                });
            })
            .then(resp => {
                $.get("/products/" + product_id + "/details").then(resp => {
                    if (resp.success !== true) return true;
                    dataLayer.push({
                        event: "add_to_cart",
                        currency: resp.currency,
                        value: resp.price,
                        items: [
                            {
                                item_id: resp.sku,
                                item_name: resp.name,
                                currency: resp.currency,
                                index: 0,
                                item_brand: resp.brand,
                                item_category: resp.category,
                                item_list_id: "search_results",
                                item_list_name: "Search Results",
                                price: resp.price,
                                quantity: 1
                            }
                        ]
                    });
                });
            });
    });

    $(".wishlist").on("click", function(e) {
        e.preventDefault();

        $.post("/toggle_wishlist", {
            product: $(this).data("product-id")
        }).then(resp => {
            //console.log(resp);
            $(this).toggleClass("in-wishlist");
        });
    });

    $(".logout").on("click", function(e) {
        e.preventDefault();
        console.log("logout");
        $.post("/logout").then(resp => {
            window.location.replace("/");
        });
    });

    $(document).on("click", ".page-link", function(e) {
        if (
            $(this)
                .parent()
                .parent()
                .parent()
                .hasClass("blog-links")
        )
            return true;

        e.preventDefault();

        if (
            $(this)
                .parent()
                .hasClass("disabled")
        )
            return false;

        let page = $(this)[0].innerHTML;
        let current = $(".page-item.active").children()[0].innerHTML;
        if (page == "»") page = parseInt(current, 10) + 1;
        if (page == "«") page = parseInt(current, 10) - 1;

        filter(page);
    });

    $(document).on("click", ".category-filter", function(e) {
        filter(1); //Reset page since there might be less results than the page we're on
    });

    $("#range_from").on("change", function(e) {
        filter(1);
    });

    $("#range_to").on("change", function(e) {
        filter(1);
    });

    $("#products-sort").on("change", function(e) {
        filter(1);
    });

    $("#products-amount").on("change", function(e) {
        filter(1);
    });

    $("input[name=search]").on("keyup", function(e) {
        let country = $("#country_hidden").val();
        let value = $(this).val();
        index
            .search($(this).val(), {
                filters: country == "au" ? "au_hidden:false" : "nz_hidden:false"
            })
            .then(({ hits }) => {
                let resp = $.post("/products/algolia_results", {
                    ids: hits.map(hit => {
                        return hit.objectID;
                    }),
                    view:
                        $(this).data("all") !== undefined
                            ? "result"
                            : "suggestion",
                    searching: { sort: "prod_az" }
                }).then(resp => {
                    return resp;
                });
                return resp;
            })
            .then(resp => {
                $("#search-autocomplete").html("");
                if (value != $(this).val())
                    //A new value's been typed in; don't display the results until that ajax returns
                    return true;

                if ($(this).data("all") === undefined)
                    resp.views.forEach(view => {
                        $("#search-autocomplete").append(view);
                    });
                else {
                    $(".pagination").remove();
                    if ($(".products__list").length < 1)
                        $(".products__main")
                            .after("<div class='products__list'></div>")
                            .remove();

                    $(".products__list")
                        .after(resp.view)
                        .remove();
                }

                if (resp.google_analytics !== undefined) {
                    dataLayer.push({
                        event: "view_item_list",
                        items: resp.google_analytics.map((item, index) => {
                            return {
                                item_id: item.sku,
                                item_name: item.name,
                                currency: item.currency,
                                index,
                                item_brand: item.brand,
                                item_category: item.category,
                                item_list_id: "search_results",
                                item_list_name: "Search Results",
                                price: item.price,
                                quantity: 1
                            };
                        })
                    });
                }
            });
    });

    if (typeof google === "object" && typeof google.maps === "object")
        createMap();
    else
        $("#store-locator-map").html(
            "<div class='maps-error'><h2>Oops! Something went wrong loading the map</h2><p>Please try refreshing the page!</p></div>"
        );
});

function createMap() {
    var markers = [];
    let storeMap = null;

    storeMap = new google.maps.Map($("#store-locator-map")[0], {
        zoom: 16,
        center: {
            lat: -37.814138,
            lng: 144.962767
        },
        panControl: true,
        zoomControl: false,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: false,
        overviewMapControl: false,
        rotateControl: false,
        styles: [
            {
                featureType: "landscape",
                stylers: [
                    {
                        hue: "#FFBB00"
                    },
                    {
                        saturation: 43.400000000000006
                    },
                    {
                        lightness: 37.599999999999994
                    },
                    {
                        gamma: 1
                    }
                ]
            },
            {
                featureType: "road.highway",
                stylers: [
                    {
                        hue: "#FFC200"
                    },
                    {
                        saturation: -61.8
                    },
                    {
                        lightness: 45.599999999999994
                    },
                    {
                        gamma: 1
                    }
                ]
            },
            {
                featureType: "road.arterial",
                stylers: [
                    {
                        hue: "#FF0300"
                    },
                    {
                        saturation: -100
                    },
                    {
                        lightness: 51.19999999999999
                    },
                    {
                        gamma: 1
                    }
                ]
            },
            {
                featureType: "road.local",
                stylers: [
                    {
                        hue: "#FF0300"
                    },
                    {
                        saturation: -100
                    },
                    {
                        lightness: 52
                    },
                    {
                        gamma: 1
                    }
                ]
            },
            {
                featureType: "water",
                stylers: [
                    {
                        hue: "#0078FF"
                    },
                    {
                        saturation: -13.200000000000003
                    },
                    {
                        lightness: 2.4000000000000057
                    },
                    {
                        gamma: 1
                    }
                ]
            },
            {
                featureType: "poi",
                stylers: [
                    {
                        hue: "#00FF6A"
                    },
                    {
                        saturation: -1.0989010989011234
                    },
                    {
                        lightness: 11.200000000000017
                    },
                    {
                        gamma: 1
                    }
                ]
            }
        ]
    });

    if ($(".store-location").length == 0) return;

    $(".store-location").click(function() {
        if (
            $(this).data("lat") == undefined ||
            $(this).data("long") === undefined
        )
            return;

        storeMap.setCenter({
            lat: $(this).data("lat"),
            lng: $(this).data("long")
        });
    });

    // Load the markers
    $(".store-location").each(function() {
        if (
            $(this).data("lat") === undefined ||
            $(this).data("long") === undefined
        )
            return;

        markers.push(
            new google.maps.Marker({
                position: {
                    lat: $(this).data("lat"),
                    lng: $(this).data("long")
                },
                icon: {
                    url: "/img/hy_location.svg",
                    scaledSize: new google.maps.Size(40, 51.46)
                },
                map: storeMap
            })
        );
    });

    if (markers.length > 0) storeMap.setCenter(markers[0].getPosition());
}

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(
            0,
            thisURL.indexOf("#") == -1 ? thisURL.length : thisURL.indexOf("#")
        );
        thisURLwithParam = thisURLwithParam.substring(
            0,
            getPosition(thisURL, "/", 2)
        );
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(
            0,
            thisURL.indexOf("#") == -1 ? thisURL.length : thisURL.indexOf("#")
        );
        thisURL = thisURL.substring(
            0,
            thisURL.indexOf("?") == -1 ? thisURL.length : thisURL.indexOf("?")
        );
        thisURL = thisURL.substring(0, getPosition(thisURL, "/", 2));
        url = thisURL;
    }

    if (url == "/") {
        url = "/home";
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(
            0,
            thisSubURL.indexOf("#") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("#")
        );
        thisURLwithParam = thisURLwithParam.substring(
            0,
            getPosition(thisSubURL, "/", 3)
        );
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(
            0,
            thisSubURL.indexOf("#") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("#")
        );
        thisSubURL = thisSubURL.substring(
            0,
            thisSubURL.indexOf("?") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("?")
        );
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, "/", 3));
        url = thisSubURL;
    }

    if (url == "/") {
        url = "/home";
    }

    return url;
}

function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
}

// -- Range Slider

const slider = document.getElementById("range");
let priceFrom = $("#price_from");
let priceTo = $("#price_to");

if (priceFrom.length > 0) {
    noUiSlider.create(slider, {
        start: [priceFrom.val(), priceTo.val()],
        step: priceTo.val() >= 1000 ? 20 : priceTo.val() >= 200 ? 10 : 5,
        margin: 20,
        tooltips: true,
        connect: true,
        behaviour: "tap-drag",
        range: {
            min: parseInt(priceFrom.val(), 10),
            max: parseInt(priceTo.val(), 10)
        }
    });

    // -- When the slider value changes, update the input and span
    //slider.noUiSlider.on('update', function( values, handle ) {
    slider.noUiSlider.on("change", function(values, handle) {
        if (handle) {
            priceTo[0].value = values[handle];
        } else {
            priceFrom[0].value = values[handle];
        }

        filter(1);
    });
}

function filter(page) {
    let country = $("#country_hidden").val();
    let search = $("input[name=search]")[0].value;
    let categories = [];
    let category_slugs = [];
    let status = $("#status_filter").val();
    $(".category-filter:checked").each(function() {
        if ($(this).data("category-name") != "Clearance") {
            categories.push($(this).data("category-name"));
            category_slugs.push($(this).data("category-slug"));
        } else status = "clearance";
    });

    let price_from = $("#price_from").val();
    let price_to = $("#price_to").val();
    let brand_id = $("#brand_id").val();
    let sort = $("#products-sort").val();
    let amount = $("#products-amount").val();

    let filters = country == "au" ? "au_hidden:false" : "nz_hidden:false";
    filters +=
        country == "au"
            ? " AND au_price:" + price_from + " TO " + price_to
            : " AND nz_price:" + price_from + " TO " + price_to;
    if (brand_id.length > 0)
        filters += " AND brands:'" + $("#brand_name").val() + "'";

    categories.forEach(value => {
        filters += " AND categories:'" + value + "'";
    });

    if (status.length > 0)
        filters +=
            country == "au"
                ? " AND au_status:" + status
                : " AND nz_status:" + status;

    switch (sort) {
        case "prod_za":
            index = client.initIndex("hyalite_products_reverse_alph");
            break;
        case "price_lowest":
            index =
                country == "au"
                    ? client.initIndex("hyalite_products_au_price_asc")
                    : client.initIndex("hyalite_products_nz_price_asc");
            break;
        case "price_highest":
            index =
                country == "au"
                    ? client.initIndex("hyalite_products_au_price_desc")
                    : client.initIndex("hyalite_products_nz_price_desc");
            break;
        case "most_popular":
            filters += " AND popular:true";
        case "prod_az":
        default:
            index = client.initIndex("hyalite_products");
            break;
    }

    let filter_object = {
        filters: filters,
        hitsPerPage: amount,
        page: page - 1
    };

    let search_filters = {
        search: search,
        categories: category_slugs,
        price_from: price_from,
        price_to: price_to,
        brand_id: brand_id,
        sort: sort,
        amount: amount,
        status: status
    };

    index
        .search(search, filter_object)
        .then(({ hits, nbPages, nbHits }) => {
            let resp = $.post("/products/algolia_results", {
                ids: hits.map(hit => {
                    return hit.objectID;
                }),
                view: "result",
                searching: search_filters,
                pages: nbPages,
                hits: nbHits,
                page: page
            }).then(resp => {
                return resp;
            });
            return resp;
        })
        .then(resp => {
            $(".pagination").remove();
            if ($(".products__main").length < 1)
                $(".sidebar").after("<div class='products__main'></div>");
            if ($(".products__list").length < 1)
                $(".products__main")
                    .after("<div class='products__list'></div>")
                    .remove();

            $(".products__list")
                .after(resp.view)
                .remove();
            history.pushState(null, null, resp.url);
            $(".products__body").after(resp.pagination);

            dataLayer.push({
                event: "view_item_list",
                items: resp.google_analytics.map((item, index) => {
                    return {
                        item_id: item.sku,
                        item_name: item.name,
                        currency: item.currency,
                        index,
                        item_brand: item.brand,
                        item_category: item.category,
                        item_list_id: "search_results",
                        item_list_name: "Search Results",
                        price: item.price,
                        quantity: 1
                    };
                })
            });

            if (resp.banner) $("#category-banner").replaceWith(resp.banner);
            else
                $("#category-banner").replaceWith(
                    "<div id='category-banner'></div>"
                );
        });
}

// -- Show brands header nav on hover

$(document).ready(function() {
    $("#header-brand").hover(
        function() {
            $(".header__branddropdown").addClass("active");
        },
        function() {
            $(".header__branddropdown").removeClass("active");
        }
    );
});

$(document).on("mouseover", ".prodcard__card", function() {
    $(".prodcard__addtocart", this).addClass("active");
    $(".prodcard__cac", this).addClass("active");
});

$(document).on("mouseleave", ".prodcard__card", function() {
    $(".prodcard__addtocart", this).removeClass("active");
    $(".prodcard__cac", this).removeClass("active");
});

$(document).on("click", ".open-atc-modal", function(e) {
    e.preventDefault();
    e.stopPropagation();

    $("#add-item-product-modal").data("product-id", $(this).data("product-id"));
});

$(document).on("click", ".click-and-collect-modal", function(e) {
    e.preventDefault();
    e.stopPropagation();

    $("#cac_modal_product").val($(this).data("product-id"));
    $("#store_selector").data("product-id", $(this).data("product-id"));
    setTimeout(() => fetchStoreStockQuantities($('#store_selector_modal')), 200);
});

$(document).on("change", "#store_selector_modal", function(e) {
    e.preventDefault();
    e.stopPropagation();

    fetchStoreStockQuantities($(this));
});

function fetchStoreStockQuantities($storeSelectorModal) {
    $("#click_and_collect_modal_details").html("");
    let product_id = $("#cac_modal_product").val();

    if ($storeSelectorModal.val().length) {
        $("#reserve_stock_modal").hide();
        $("#no_stock_modal").hide();
        $("#click_and_collect_modal_details").html(
            "Checking stock levels, please wait..."
        );
        $.get(
            `/check_stock/${product_id}?warehouse=${$storeSelectorModal.val()}`
        ).then(resp => {
            if (resp.stock > 0) $("#reserve_stock_modal").show();
            else $("#no_stock_modal").show();
            $("#click_and_collect_modal_details").html(resp.view);
            $("#cac_modal_quantity").attr("max", resp.stock);
            if ($("#cac_modal_quantity").val() > resp.stock)
                $("#cac_modal_quantity").val(resp.stock);
        });
    }
}

$(document).on("click", ".out-of-stock", function(e) {
    e.preventDefault();
});

$(document).on("click", ".phonecall", function(e) {
    e.preventDefault();
    //console.log($(this).data("number"));
    dataLayer.push({ event: "initiatePhoneCall" });

    window.location.href = $(this).attr("href");
});

$(document).on("click", ".product-link", function(e) {
    e.preventDefault();

    let product_id = $(this).data("product-id");

    $.get("/products/" + product_id + "/details")
        .then(resp => {
            if (resp.success !== true || !window.ga)
                document.location = $(this).attr("href");

            return new Promise((resolve, reject) => {
                dataLayer.push({
                    event: "select_item",
                    items: [
                        {
                            item_id: resp.sku,
                            item_name: resp.name,
                            currency: resp.currency,
                            index: 0,
                            item_brand: resp.brand,
                            item_category: resp.category,
                            item_list_id: "search_results",
                            item_list_name: "Search Results",
                            price: resp.price,
                            quantity: 1
                        }
                    ]
                });
                resolve({ success: true, slug: resp.slug });
            });
        })
        .then(resp => {
            document.location = "/products/" + resp.slug;
        });
});

$(function() {
    $(".header__catbrands > ul .li-overlay").on("mouseover", function() {
        $(".navoverlay").show();
    });
    $(".header__catbrands > ul .li-overlay").on("mouseout", function() {
        $(".navoverlay").hide();
    });

    $(".header__branddropdown").on("mouseover", function() {
        $(".navoverlay").show();
    });
    $(".header__branddropdown").on("mouseout", function() {
        $(".navoverlay").hide();
    });
});

// -- Overlay Toggle
$("#toggle").click(function() {
    $(this).toggleClass("active");
    $("#overlay").toggleClass("open");
});

// -- Swap the slogan icon header on mobile
setInterval(function() {
    let slogan = $("#slogan").children();
    let activeIndex = 0;
    slogan.each(function(index) {
        if ($(this).hasClass("active")) {
            activeIndex = index;
            return;
        }
    });
    slogan.removeClass("active");
    slogan.eq((activeIndex + 1) % slogan.length).addClass("active");
}, 2500);

// -- Read more

/*$(".review-product-text").readmore({
    speed: 75, //Açılma Hızı
    collapsedHeight: 50, // 100px sonra yazının kesileceğini belirtir.
    moreLink: '<a class="ac" href="#">Show more</a>', // açma linki yazısı
    lessLink: '<a class="kapat" href="#">Show Less</a>' // kapatma linki yazısı
});*/
